export default [{
    header: 'Organization',
    roles: {
      admin: ["read", "write"],
      consultant: ["read", "write"],
      client: ["read", "write"],
      supervisor: ["read", "write"],
      director: ["read", "write"],
    }
  },
  {
    title: 'Calendar',
    route: 'apps-calendar',
    icon: 'CalendarIcon',
    roles: {
      admin: ["read", "write"],
      consultant: ["read", "write"],
      supervisor: ["read", "write"],
      director: ["read", "write"],
      client: ["read", "write"],
    }
  },
  {
    title: 'Organization',
    icon: 'FilmIcon',
    roles: {
      admin: ["read", "write"],
      consultant: ["read", "write"],
      client: ["read", "write"],
      supervisor: ["read", "write"],
      director: ["read", "write"],
    },
    children: [{
        title: 'Employees',
        route: 'organization-worker-list',
        roles: {
          admin: ["read", "write"],
          consultant: ["read", "write"],
          client: ["read", "write"],
          supervisor: ["read", "write"],
          director: ["read", "write"],
        },
      },
      {
        title: 'Roles',
        route: 'organization-role-list',
        roles: {
          admin: ["read", "write"],
          client: ["read", "write"],
          consultant: ["read", "write"]
        },
      },
      {
        title: 'Locations',
        route: 'organization-location-list',
        roles: {
          admin: ["read", "write"],
          client: ["read", "write"],
          consultant: ["read", "write"]
        },
      },
      {
        title: 'Physical Locations',
        route: 'organization-physical_location-list',
        roles: {
          admin: ["read", "write"],
          client: ["read", "write"],
          consultant: ["read", "write"]
        },
      },
      {
        title: 'Areas',
        route: 'organization-area-list',
        roles: {
          admin: ["read", "write"],
          client: ["read", "write"],
          consultant: ["read", "write"]
        },
      },
      {
        title: 'Feedback Points',
        route: 'organization-feedbackPoint-list',
        roles: {
          admin: ["read", "write"],
          client: ["read", "write"],
          consultant: ["read", "write"]
        },
      },
      {
        title: 'Metadata',
        route: 'organization-metadata-list',
        roles: {
          admin: ["read", "write"],
          client: ["read", "write"],
          consultant: ["read", "write"]
        },
      },
      {
        title: 'Behaviours',
        route: 'organization-behaviour-list',
        roles: {
          admin: ["read", "write"],
          client: ["read", "write"],
          consultant: ["read", "write"]
        },
      },
      {
        title: 'Values',
        route: 'organization-value-list',
        roles: {
          admin: ["read", "write"],
          client: ["read", "write"],
          consultant: ["read", "write"]
        },
      },
    ],
  },
  {
    title: 'Dashboards',
    icon: 'DatabaseIcon',
    roles: {
      admin: ["read", "write"],
      client: ["read", "write"],
      consultant: ["read", "write"]
    },
    children: [
      {
        title: 'Department',
        route: 'habit-department-report',
        roles: {
          admin: ["read", "write"],
          client: ["read", "write"],
          consultant: ["read", "write"]
        }
      },
      {
        title: 'Area/Physical Location',
        route: 'habit-area-physical_location-report',
        roles: {
          admin: ["read", "write"],
          client: ["read", "write"],
          consultant: ["read", "write"]
        }
      },
    ]
  },
  {
    title: 'QR Codes',
    icon: 'GridIcon',
    roles: {
      consultant: ["read", "write"]
    },
    children: [
      {
        title: 'Create QR',
        route: 'organization-qr-generator-add',
        roles: {
          consultant: ["read", "write"]
        }
      },
      {
        title: 'QR List',
        route: 'organization-qr-generator-list',
        roles: {
          consultant: ["read", "write"]
        }
      },
    ]
  },
]